import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeGetAppInstallLinkResponse = {
  code: string;
  message: string;
  data: TypeAppInstallLink;
};

export type TypeAppInstallLink = {
  aos: string;
  ios: string;
};

/** @description 앱 설치 링크 조회 api 요청에 사용되는 커스텀 훅 */
export const useGetAppInstallLink = () => {
  const queryClient = useQueryClient();

  const requestGetAppInstallLink = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (response: TypeGetAppInstallLinkResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
  }) => {
    const endpoint = '/kurlyro-support/app-install-link';

    const query = queryClient.ensureQueryData<AxiosResponse<TypeGetAppInstallLinkResponse>>({
      queryKey: ['kurlyro-support', 'app-install-link'],
      queryFn: () => axiosInstance.get(endpoint, { headers: { withoutToken: true } }),
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestGetAppInstallLink;
};
